import React, { useContext, useEffect } from "react";
import { Box, Dialog, Button, IconButton, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { observer } from "mobx-react-lite";
import CloseIcon from "@mui/icons-material/Close";
import GuiasEmbarque from "../../components/usuarios/GuiasEmbarque";
import ActualizacionesTracker from "../components/ActualizacionesTracker";
import InfoGeneralEmbarque from "../../components/usuarios/InfoGeneralEmbarque";
import { RootStoreContext } from "../../app/store/root";
import { EnumStatusEmbarqueString } from "../Enumerables";

export const ModalDetalleEmbarque = ({ onClose }) => {
    const rootStore = useContext(RootStoreContext);
    const { 
        entity,
        consultarComprobanteArchivo: _consultarComprobanteArchivo
     } = rootStore.embarqueStore

    useEffect(() => {
        
    }, [])

    const consultarComprobanteArchivo = async (event) => {        
        event.preventDefault()
        rootStore.logisticBackdropStore.openLoading()
        await _consultarComprobanteArchivo(entity.idEmbarque)
        rootStore.logisticBackdropStore.closeLoading()
    }

    return (
        <div>
            <DialogTitle>
                Detalles del embarque #{entity?.numeroCartaPorte}
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Box>
                    <Box>
                        <InfoGeneralEmbarque />
                    </Box>
                    <Box mt={1}>
                        <GuiasEmbarque />
                    </Box>
                    <Box mt={1}>
                        <ActualizacionesTracker tipo='embarques' />
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions variant="paddi">
                {entity.estatus.toUpperCase() == EnumStatusEmbarqueString.Entregado &&
                    <Button
                        onClick={(e) => consultarComprobanteArchivo(e)}
                        variant="contained"
                        color="secondary"
                        sx={{ color: "#fff" }}
                    >
                        Ver comprobante
                    </Button>
                }
                <Button onClick={onClose} variant="contained">
                    Cerrar
                </Button>
            </DialogActions>
        </div>
    );
};

export default observer(ModalDetalleEmbarque);